import { render, staticRenderFns } from "./ProductTileTitle.vue?vue&type=template&id=43474f0e&"
import script from "./ProductTileTitle.vue?vue&type=script&lang=js&"
export * from "./ProductTileTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports